import { setupInterceptors } from '../axios-controller';
import { store } from '../redux/store';

let isSetup = false;

export const initializeAxios = (navigate) => {
    if (!isSetup) {
        setupInterceptors(store.dispatch, navigate || ((path) => {
            window.location.href = path;
        }));
        isSetup = true;
    }
};

initializeAxios();